<template>
  <div
    :id="$options.consts.ELEMENT_ID.VOTE_FORM"
    class="voting-vote-section__wrapper full-width-section"
  >
    <div class="voting-vote-section__container">
      <voting-vote-form
        :categories-response="categoriesResponse"
        :in-progress="inProgress"
        :was-authorized-data-received="wasAuthorizedDataReceived"
        :was-error-on-categories-request="wasErrorOnCategoriesRequest"
      />
    </div>
  </div>
</template>

<script>
import { ELEMENT_ID } from 'enums/element-id'
import VotingVoteForm from 'sections/_voting/VotingVoteSection/VotingVoteForm'
import { PROP_TYPES, propValidator } from '@fmpedia/validators'

export default {
  name: 'VotingVoteSection',
  consts: {
    ELEMENT_ID
  },
  components: { VotingVoteForm },
  props: {
    categoriesResponse: propValidator([PROP_TYPES.OBJECT]),
    inProgress: propValidator([PROP_TYPES.BOOLEAN]),
    wasAuthorizedDataReceived: propValidator([PROP_TYPES.BOOLEAN]),
    wasErrorOnCategoriesRequest: propValidator([PROP_TYPES.BOOLEAN])
  }
}
</script>

<style lang="scss" scoped>
.voting-vote-section__wrapper {
  background: $c--background-dark-4;

  .voting-vote-section__container {
    max-width: $desktop-container;

    $padding: (
      $above-desktop-xl: 64px $padding-x-desktop-full-hd 0,
      $desktop-sm: 64px $padding-x-desktop-sm 0,
      $mobile: 32px $padding-x-mobile 0
    );

    @include setStyleByBreakpoint('padding', $padding);
  }
}
</style>
